module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cMnkn"))).then(() => parcelRequire('d0iPb'));